import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

function KeyOperatorFilter({ entityConfig, keysWithOperators, onKeyChange }) {
  const selectedKeys = keysWithOperators.map(({ key }) => key);
  const fields = entityConfig.entityStructure.fields;

  return (
    <Tooltip
      title={
        selectedKeys.length > 0
          ? selectedKeys.map((key) => fields[key].label).join(", ")
          : "Select fields to filter by"
      }
      placement="top"
      arrow
    >
      <FormControl
        sx={{
          m: 1,
          width: 120,
          "& .MuiOutlinedInput-root": { borderRadius: "16px" },
        }}
        size="small"
      >
        <Select
          multiple
          value={selectedKeys}
          onChange={(e) => onKeyChange(e.target.value || [])}
          displayEmpty
          renderValue={(selected) =>
            selected.length > 0 ? (
              selected.map((key) => fields[key].label).join(", ")
            ) : (
              <span>Filter</span>
            )
          }
          MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
          input={
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">
                  <TuneIcon />
                </InputAdornment>
              }
            />
          }
        >
          {Object.entries(fields)
            .filter(
              ([_, field]) =>
                field.filterOperators &&
                field.filterOperators.length > 0 &&
                !field.isHiddenInTable
            )
            .map(([key, field]) => (
              <MenuItem key={key} value={key}>
                {field.label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
}

export default KeyOperatorFilter;
